<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <div class="title" style="margin-top:20px;">To-Do-Liste</div>
        </span>
      </template>
      <span>
        Spezielle Maßnahmen die dieses Verfahren betreffen<br />
        und nicht einer allgemeinen TOM zugeordnet werden können.<br />
        Wenn eine Maßnahme eine der gelisteten allgemeinen TOMs betrifft,<br />
        führen Sie die Maßnahme dort als Einzelmaßnahme auf.
      </span>
    </v-tooltip>
    <v-list>
      <measure-list-item
        v-for="(processMeasure, index) in processMeasures"
        v-bind:item="processMeasure"
        v-bind:index="index"
        :oldItem="Object.assign({}, processMeasure)"
        v-on:update-item="updateProcessMeasure"
        v-on:delete-item="deleteProcessMeasure"
        :key="processMeasure.id"
      />
      <measure-list-new-item v-bind:newItem="newProcessMeasure" v-on:create-item="createProcessMeasure" />
    </v-list>
  </div>
</template>

<script>
import MeasureListItem from "./lib/MeasureListItem";
import MeasureListNewItem from "./lib/MeasureListNewItem";

import { createProcessMeasure, updateProcessMeasure, deleteProcessMeasure } from "../graphql/mutations";

export default {
  components: {
    MeasureListItem,
    MeasureListNewItem,
  },
  name: "ProcessMeasureListView",
  props: {
    companyId: String,
    processId: String,
    processMeasures: Array,
    assessment_necessary: Boolean,
  },
  computed: {
    createProcessMeasureMutation() {
      return this.$Amplify.graphqlOperation(createProcessMeasure, { input: this.newProcessMeasure });
    },
    updateProcessMeasureMutation() {
      return this.$Amplify.graphqlOperation(updateProcessMeasure, { input: this.currentProcessMeasure });
    },
    deleteProcessMeasureMutation() {
      return this.$Amplify.graphqlOperation(deleteProcessMeasure, { input: this.currentProcessMeasure });
    },
  },
  mounted() {
    this.initNewProcessMeasure(this.$route.params.pid);
  },
  watch: {
    assessment_necessary: function(new_value) {
      console.log("did change assessment_necessary", new_value, this);
      if (new_value === true) {
        // create DSFA measure
        var processMeasure = {
          auto_managed: true,
          status: "OPEN",
          label: "DSFA ist durchzuführen",
          description: "Eine Datenschutz-Folgenabschätzung (DSFA) wurde durchgeführt.",
          processMeasureProcessId: this.processId,
        };
        this.newProcessMeasure = processMeasure;
        this.createProcessMeasure();
      } else {
        // delete DSFA measure
        var dsfa_measures = this.processMeasures.filter((x) => x.auto_managed === true && x.label.startsWith("DSFA"));
        dsfa_measures.forEach((x) => {
          let index = this.processMeasures.indexOf(x);
          this.deleteProcessMeasure(x, index);
        });
      }
    },
  },
  methods: {
    initNewProcessMeasure(pid) {
      this.newProcessMeasure = {
        label: "",
        status: "OPEN",
        processMeasureProcessId: pid,
      };
    },
    //toggleProcessMeasureStatus(oldProcessMeasure, processMeasure, index) {
    //  //this.$emit('toggle-item-status', item, index);
    //  this.updateProcessMeasure(oldProcessMeasure, processMeasure, index);
    //},
    createProcessMeasure() {
      //this.$emit('create-item', item)
      //console.log('createProcessMeasure', processMeasure)
      this.$eventHub.emit("sync-status-syncing");
      this.$Amplify.API.graphql(this.createProcessMeasureMutation)
        .then((response) => {
          this.onProcessMeasureCreated(response);
          this.$eventHub.emit("sync-status-success", {
            entity_type: "To-Do",
            entity_label: response.data.createProcessMeasure.label,
            sync_type: "create",
          });
        })
        .catch((err) => {
          console.error(err);
          this.$eventHub.emit("sync-status-failure", {
            entity_type: "To-Do",
            entity_label: this.newProcessMeasure.label,
            sync_type: "create",
            error: err.errors[0].message,
          });
        });
    },
    updateProcessMeasure(oldProcessMeasure, processMeasure, index) {
      //this.$emit('update-item', item, index);
      this.$eventHub.emit("sync-status-syncing");
      this.currentProcessMeasure = processMeasure;
      delete this.currentProcessMeasure.process;
      this.$Amplify.API.graphql(this.updateProcessMeasureMutation)
        .then((response) => {
          this.$recordUpdate(
            this.companyId,
            "PROCESSMEASURE",
            oldProcessMeasure,
            this.currentProcessMeasure,
            (res, err) => {
              res
                ? console.log("logged PROCESSMEASURE update", res)
                : console.error("error logging PROCESSMEASURE update", err, e);
            }
          );
          this.onProcessMeasureUpdated(response, index);
          this.$eventHub.emit("sync-status-success", {
            entity_type: "To-Do",
            entity_label: processMeasure.label,
            sync_type: "update",
          });
        })
        .catch((err) => {
          console.error(err);
          this.$eventHub.emit("sync-status-failure", {
            entity_type: "To-Do",
            entity_label: processMeasure.label,
            sync_type: "update",
            error: err.errors[0].message,
          });
        });
    },
    deleteProcessMeasure(processMeasure, index) {
      //this.$emit('delete-item', item, index);
      this.$eventHub.emit("sync-status-syncing");
      this.currentProcessMeasure = { id: processMeasure.id };
      this.$Amplify.API.graphql(this.deleteProcessMeasureMutation)
        .then((response) => {
          processMeasure.processMeasureProcessId = this.processId;
          this.$recordDelete(this.companyId, "PROCESSMEASURE", processMeasure, (res, err) => {
            res
              ? console.log("logged PROCESSMEASURE delete", res)
              : console.error("error logging PROCESSMEASURE delete", err, e);
          });
          this.onProcessMeasureDeleted(index);
          this.$eventHub.emit("sync-status-success", {
            entity_type: "To-Do",
            entity_label: processMeasure.label,
            sync_type: "delete",
          });
        })
        .catch((err) => {
          console.error(err);
          this.$eventHub.emit("sync-status-failure", {
            entity_type: "To-Do",
            entity_label: processMeasure.label,
            sync_type: "delete",
            error: err.errors[0].message,
          });
        });
    },
    onProcessMeasureCreated(resp) {
      //var processMeasure = resp.data.createProcessMeasure;
      this.newProcessMeasure.id = resp.data.createProcessMeasure.id;
      this.$recordCreate(this.companyId, "PROCESSMEASURE", this.newProcessMeasure, (res, err) => {
        res
          ? console.log("logged PROCESSMEASURE create", res)
          : console.error("error logging PROCESSMEASURE create", err, e);
      });
      this.$emit("processMeasureCreated", this.newProcessMeasure);
      this.initNewProcessMeasure(this.$route.params.pid);
    },
    onProcessMeasureUpdated(resp, index) {
      //var processMeasure = resp.data.updateProcessMeasure;
      this.$emit("processMeasureUpdated", this.currentProcessMeasure, index);
      this.currentProcessMeasure = null;
    },
    onProcessMeasureDeleted(index) {
      this.$emit("processMeasureDeleted", index);
    },
  },
  data: () => ({
    newProcessMeasure: null,
    currentProcessMeasure: null,
    oldProcessMeasure: null,
  }),
};
</script>

<style scoped></style>
